module.exports = new Promise(function (resolve, reject) {
					var __webpack_error__ = new Error()
					if (typeof window["policy"] !== 'undefined') return resolve();
					__webpack_require__.l(
						"https://app.travel-policy.preprod.platform-services.fctg.global/remoteEntry.js",
						function (event) {
							if (typeof policy !== 'undefined') return resolve();
							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
							var realSrc = event && event.target && event.target.src;
							__webpack_error__.message =
								'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
							__webpack_error__.name = 'ScriptExternalLoadError';
							__webpack_error__.type = errorType;
							__webpack_error__.request = realSrc;
							reject(__webpack_error__);
						},
						"policy",
					);
				}).then(function(){
					var proxy = {
						get: function(request) {
							return Promise.resolve().then(function() { return policy.get(request); }).then(function(factory) {
								return function() {
									try { return factory(); }
									catch(e) {
										console.warn('remote policy factory error for ' + request, e);
										return undefined;
									}
								};
							}).catch(function(e) {
								console.warn('remote policy chunk load failed for ' + request, e);
								return function() { return undefined; };
							});
						},
						init: policy.init
					}
					return proxy
				}).catch(function(e) {
					console.warn('remote policy is not available', e);
					let newProxy = {
						get: (module, scope) => () => undefined,
						init: () => {}
					}
					return(newProxy);
				});